// extracted by mini-css-extract-plugin
module.exports = {"input":"_28XbM4yV40X4G4HDfntav2"};